export class ViewerLayout {
    constructor(config, eventBus, assetViewerItems) {
        this.config = config;
        this.eventBus = eventBus;
        this.assetViewerItems = assetViewerItems;
        this.layoutHeight = null;
        this.lastNavigatedNext = true;
        this._viewState = null;
        this._currentView = null;
    }
    get viewState() {
        return this._viewState;
    }
    set currentView(view) { }
    get currentView() {
        return this._currentView;
    }
    addEventListeners() { }
    removeEventListeners() { }
    // addViews() {
    //
    // }
    update(index = null, adjustScrollPosition = true, viewportWidthChanged = false) { }
    render(container) { }
    resize() { }
    destroy() {
        this.removeEventListeners();
    }
    createContentContainer(AssetViewerView) {
        return document.createElement('div');
    }
    createContentWrapper() {
        return document.createElement('div');
    }
    createContainer() {
        return document.createElement('div');
    }
    destroyViewContainer(view) { }
    renderViewContainer(view) { }
}
//# sourceMappingURL=ViewerLayout.js.map